import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';

export interface Plan {
  id: number;
  name: string;
  price: string;
  activeUsers: number;
  growth: number;
  features: string;
  status: 'active' | 'inactive';
}

export interface PlanDetails {
  productId: string;
  platform: 'ios' | 'android' | 'both';
  subscriptionType: string;

  name: string;
  description: string;

  duration: number;
  price: number;
  currency: string;

  limits: {
    dailySwipes: number;
    dailyPops: number;
    dailySuperLikes: number;
    dailyRewinds: number;
  };

  features: string[];

  appStoreProductId: string;
  playStoreProductId: string;

  isActive: boolean;

  createdAt: string;
  updatedAt: string;

  selected?: boolean;
}


@Component({
  selector: 'app-plan-modal',
  standalone: true,
  imports: [CommonModule, DialogModule,TagModule],
  templateUrl: './plan-modal.component.html',
  styleUrl: './plan-modal.component.css'
})
export class PlanModalComponent implements OnInit {
  @Input() isVisible = false;
  @Input() plan: PlanDetails | null = null;
  @Input() isLoading = false;
  
  @Output() close = new EventEmitter<boolean>();
  
  ngOnInit(): void {
    // Component initialization
  }
  
  onClose(): void {
    this.close.emit();
  }

  get modalTitle(): string {
    return this.plan ? `${this.plan.name} Details` : 'Plan Details';
  }
  
}
